"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileQuestion: function() {
        return FileQuestion;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileQuestion = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V9H14C13.4477 9 13 8.55228 13 8V3H6ZM15 4.41421L17.5858 7H15V4.41421ZM11.9673 13C11.5027 13 11.1098 13.3177 10.9987 13.7493C10.861 14.2841 10.3159 14.6061 9.78101 14.4684C9.24616 14.3308 8.92417 13.7856 9.06184 13.2507C9.39481 11.957 10.568 11 11.9673 11C13.6241 11 14.9673 12.3431 14.9673 14C14.9673 14.9314 14.5128 15.5493 14.0367 16.0087C13.8439 16.1949 13.6243 16.3769 13.4269 16.5405C13.3978 16.5646 13.3691 16.5883 13.3412 16.6116C13.1107 16.8033 12.8902 16.9913 12.6744 17.2071C12.2839 17.5976 11.6507 17.5976 11.2602 17.2071C10.8697 16.8166 10.8697 16.1834 11.2602 15.7929C11.5443 15.5087 11.8238 15.2723 12.0622 15.074C12.0937 15.0478 12.1242 15.0225 12.1536 14.998C12.3582 14.8282 12.5134 14.6994 12.6478 14.5697C12.9218 14.3053 12.9673 14.1732 12.9673 14C12.9673 13.4477 12.5195 13 11.9673 13ZM10.9668 19C10.9668 18.4477 11.4145 18 11.9668 18H11.9768C12.5291 18 12.9768 18.4477 12.9768 19C12.9768 19.5523 12.5291 20 11.9768 20H11.9668C11.4145 20 10.9668 19.5523 10.9668 19Z",
        fill: "currentColor"
    })
}), "FileQuestion");
const _default = FileQuestion;
